import React from 'react';
import { Line } from 'react-chartjs-2';
var chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
        x: {
            border: {
                color: 'white',
                width: 1,
            },
            ticks: {
                color: 'white',
            }
        },
        y: {
            beginAtZero: true,
            border: {
                color: 'white',
                width: 1,
            },
            ticks: {
                color: 'white',
            }
        },
    },
    plugins: {
        tooltip: {
            mode: 'index',
            intersect: false,
        },
        legend: {
            display: false,
        },
        lineChartIcons: {
            enabled: false,
        },
        barChartLabelIcons: {
            enabled: false,
        },
        barChartMiniLabelIcons: {
            enabled: false,
        },
        crosshair: false,
        zoom: false,
    },
};
var UsageCharts = function (_a) {
    var data = _a.data;
    var users = data.users, downloads = data.downloads, daus = data.daus, waus = data.waus, maus = data.maus, gppd = data.gppd, weekly_retention = data.weekly_retention, monthly_retention = data.monthly_retention;
    // Users
    var userDates = Object.keys(users).sort();
    var userData = userDates.map(function (date) { return users[date] || 0; });
    // Downloads
    var downloadDates = Object.keys(downloads).sort();
    var downloadData = downloadDates.map(function (date) { return downloads[date] || 0; });
    // DAUs and GPPDs
    var dailyDates = Object.keys(daus).sort();
    var dausData = dailyDates.map(function (date) { return daus[date] || 0; });
    var gppdData = dailyDates.map(function (date) { return gppd[date] || 0; });
    // WAUs
    var weeklyDates = Object.keys(waus).sort();
    var wausData = weeklyDates.map(function (week) { return waus[week] || 0; });
    // MAUs
    var monthlyDates = Object.keys(maus).sort();
    var mausData = monthlyDates.map(function (month) { return maus[month] || 0; });
    // Retention
    var weekly_cohorts = Object.keys(weekly_retention).sort();
    var weeklyRetentionData = weekly_cohorts.map(function (cohort) {
        var cohortData = weekly_retention[cohort];
        return {
            label: cohort,
            data: Object.values(cohortData),
            borderColor: "rgba(".concat(Math.random() * 255, ",").concat(Math.random() * 255, ",").concat(Math.random() * 255, ",1)"),
            backgroundColor: "rgba(".concat(Math.random() * 255, ",").concat(Math.random() * 255, ",").concat(Math.random() * 255, ",0.2)"),
        };
    });
    var monthly_cohorts = Object.keys(monthly_retention).sort();
    var monthlyRetentionData = monthly_cohorts.map(function (cohort) {
        var cohortData = monthly_retention[cohort];
        return {
            label: cohort,
            data: Object.values(cohortData),
            borderColor: "rgba(".concat(Math.random() * 255, ",").concat(Math.random() * 255, ",").concat(Math.random() * 255, ",1)"),
            backgroundColor: "rgba(".concat(Math.random() * 255, ",").concat(Math.random() * 255, ",").concat(Math.random() * 255, ",0.2)"),
        };
    });
    var usersChartData = {
        labels: userDates.map(function (date) { return new Date(date).toLocaleDateString(); }),
        datasets: [{
                label: 'Users',
                data: userData,
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
            }],
    };
    var downloadsChartData = {
        labels: downloadDates.map(function (date) { return new Date(date).toLocaleDateString(); }),
        datasets: [{
                label: 'Downloads',
                data: downloadData,
                borderColor: 'rgba(255, 206, 86, 1)',
                backgroundColor: 'rgba(255, 206, 86, 0.2)',
            }],
    };
    var dausChartData = {
        labels: dailyDates.map(function (date) { return new Date(date).toLocaleDateString(); }),
        datasets: [{
                label: 'Daily Active Users (DAUs)',
                data: dausData,
                borderColor: 'rgba(75,192,192,1)',
                backgroundColor: 'rgba(75,192,192,0.2)',
            }],
    };
    var wausChartData = {
        labels: weeklyDates.map(function (date) { return new Date(date).toLocaleDateString(); }),
        datasets: [{
                label: 'Weekly Active Users (WAUs)',
                data: wausData,
                borderColor: 'rgba(255,99,132,1)',
                backgroundColor: 'rgba(255,99,132,0.2)',
            }],
    };
    var mausChartData = {
        labels: monthlyDates.map(function (date) { return new Date(date).toLocaleDateString(); }),
        datasets: [{
                label: 'Monthly Active Users (MAUs)',
                data: mausData,
                backgroundColor: 'rgba(255,159,64,0.6)',
            }],
    };
    var gppdChartData = {
        labels: dailyDates.map(function (date) { return new Date(date).toLocaleDateString(); }),
        datasets: [{
                label: 'Games Played Per Day',
                data: gppdData,
                borderColor: 'rgba(153,102,255,1)',
                backgroundColor: 'rgba(153,102,255,0.2)',
            }],
    };
    var weeklyRetentionChartData = {
        labels: Array.from({ length: Math.max.apply(Math, Object.values(weekly_retention).map(function (obj) { return Object.keys(obj).length; })) }, function (_, i) { return "Week ".concat(i + 1); }),
        datasets: weeklyRetentionData,
    };
    var monthlyRetentionChartData = {
        labels: Array.from({ length: Math.max.apply(Math, Object.values(monthly_retention).map(function (obj) { return Object.keys(obj).length; })) }, function (_, i) { return "Month ".concat(i + 1); }),
        datasets: monthlyRetentionData,
    };
    var chartStyle = {
        height: '400px',
        width: '100%',
        marginBottom: 125,
    };
    return (React.createElement("div", { style: { width: '100%', minHeight: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'center', marginLeft: 'auto', marginRight: 'auto', marginTop: 50 } },
        React.createElement("div", { style: chartStyle },
            React.createElement("h2", null, "Users"),
            React.createElement(Line, { options: chartOptions, data: usersChartData })),
        React.createElement("div", { style: chartStyle },
            React.createElement("h2", null, "Downloads"),
            React.createElement(Line, { options: chartOptions, data: downloadsChartData })),
        React.createElement("div", { style: chartStyle },
            React.createElement("h2", null, "Daily Active Users"),
            React.createElement(Line, { options: chartOptions, data: dausChartData })),
        React.createElement("div", { style: chartStyle },
            React.createElement("h2", null, "Weekly Active Users"),
            React.createElement(Line, { options: chartOptions, data: wausChartData })),
        React.createElement("div", { style: chartStyle },
            React.createElement("h2", null, "Monthly Active Users"),
            React.createElement(Line, { options: chartOptions, data: mausChartData })),
        React.createElement("div", { style: chartStyle },
            React.createElement("h2", null, "Games Played Per Day"),
            React.createElement(Line, { options: chartOptions, data: gppdChartData })),
        React.createElement("div", { style: chartStyle },
            React.createElement("h2", null, "Weekly Retention"),
            React.createElement(Line, { options: chartOptions, data: weeklyRetentionChartData })),
        React.createElement("div", { style: chartStyle },
            React.createElement("h2", null, "Monthly Retention"),
            React.createElement(Line, { options: chartOptions, data: monthlyRetentionChartData }))));
};
export default UsageCharts;
